import utils from "./Utils.js";
import plotMgrInstance from "./PlotMgr.js"
import * as d3 from "d3";
import {Plot} from "./Plot.js"

class HistogramPlot extends Plot{
    constructor(initParams) {
        super(initParams)
    }

    addHistogramPlot(newData, idForPlotCreation, keyForPlotCreation, layoutType, divisions = 5, flipAxis = false, idKeyValue = undefined, chartFormatting) {
        try {
            let scope = this;

            let formatting = { ...utils.defaultFormatting, ...(chartFormatting || {}) };
            scope.formatting = formatting
            let dataObj = {};
            let dataArr = [];
            scope.keys.x = keyForPlotCreation;
            scope.keys.y = idKeyValue;

            scope.canvas.innerHTML = "";
            if (layoutType == 'value') {
                let response = utils.filterNumberTypeData(newData, idForPlotCreation, keyForPlotCreation, idKeyValue);
                if (response.status == 'success') {
                    dataObj = response.data;
                }
            }
            else {
                let response = utils.filterOtherTypeData(newData, idForPlotCreation, keyForPlotCreation, idKeyValue);
                if (response.status == 'success') {
                    dataObj = response.data;
                }
            }

            dataArr = dataObj.data;

            //Determine necessary padding to not cut off text
            let min = Math.min.apply(null, dataArr.map(d => d.key));
            let max = Math.max.apply(null, dataArr.map(d => d.key));
            let dataTemp = [min, max]
            //Number of characters in the longest dependent variable
            const independentVariableLength = utils.getMaxCharactersForNumber(dataTemp)
            let axisAngleRadians = utils.toRadians(scope.formatting.axisAngle)

            //Independent Axis on Bottom
            if (flipAxis == true){
                scope.paddingY = independentVariableLength*Math.sin(axisAngleRadians)*5
                scope.paddingX = 0
            }
            else { //Independent Axis On Left
                scope.paddingX = independentVariableLength*Math.cos(axisAngleRadians)*5
                scope.paddingY = 0
            }
            
            let width = scope.canvas.clientWidth - scope.margin.left - scope.margin.right - scope.paddingX
            let height = scope.canvas.clientHeight - scope.margin.top - scope.margin.bottom - scope.paddingY

            let dimensions = "0 0 " + scope.canvas.offsetWidth + " " + scope.canvas.offsetHeight;
            let divs = divisions;

            let padding = (max - min) / divs;
            min = min - padding;
            max = max + padding;
            
            //Set Scope Values
            scope.min = min
            scope.max = max
            scope.dataObj = dataObj
            scope.dataArr = dataArr
            scope.formatting = formatting
            scope.flipAxis = flipAxis

            // append the svg object to the body of the page
            scope.svg = d3.select(scope.canvas)
                .append('svg')
                .attr("viewBox", dimensions)
                .attr("preserveAspectRatio", "xMinYMin meet")
                .append('g')
                .attr('transform',
                    'translate(' + scope.margin.left + ',' + scope.margin.top + ')');

            scope.tooltip = d3.select(scope.canvas).append("div");
            utils.formatTooltipDefault(scope.tooltip, scope.defaultColor);

            let items = {};
            let axisX = {};
            let axisY = {};
            let gridX = {};
            let gridY = {};

            if (flipAxis == true) {

                // █▀▀ █▀▀ ▄▀▄ █   █▀▀ 
                // ▄██ █▄▄ █▀█ █▄▄ ██▄ 

                let x = d3.scaleLinear()
                    .domain([min, max])
                    .range([0, width]);

                let histogram = d3.histogram()
                    .value(function (d) { return d.key; })
                    .domain(x.domain())
                    .thresholds(x.ticks(divs));

                let bins = histogram(dataArr);

                bins.forEach(bin => {
                    bin.sum = bin.map(d => d.value).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
                });

                bins.forEach(bin => {
                    let ids = [];
                    bin.forEach(element => {
                        element.ids.forEach(id => {
                            scope.elements[id] = bin.x0;
                            ids.push(id);
                        });
                    });
                    scope.data[bin.x0] = {
                        key: bin.x0,
                        min: bin.x0,
                        max: bin.x1,
                        ids: ids,
                        value: bin.sum,
                    };
                });

                scope.bins = bins

                let y = d3.scaleLinear()
                    .range([height, 0]);
                y.domain([0, Math.max.apply(null, bins.map(d => d.sum))]);

                // ▄▀▄ ▀▄▀ ▀█▀ █▀▀ 
                // █▀█ █ █ ▄█▄ ▄██   

                axisX = scope.svg.append('g')
                .attr('name', 'axisX')
                    .attr('transform', 'translate(0,' + height + ')')
                    .attr('color', scope.axisColor)
                    .style('pointer-events', 'none')
                    .call(d3.axisBottom(x));

                axisY = scope.svg.append('g')
                .attr('name', 'axisY')
                    .attr('color', scope.axisColor)
                    .style('pointer-events', 'none')
                    .call(d3.axisLeft(y));

                    // █▀▀ █▀█ ▀█▀ █▀▄ 
                    // █▄█ █▀▄ ▄█▄ █▄▀ 

                gridY = scope.svg.append("g")
                    .attr("transform", "translate(" + 0 + "," + height + ")")
                    .attr('name', 'gridY')
                    .call(d3.axisBottom(x).tickSize(-height).tickFormat(""));

                gridX = scope.svg.append("g")
                    .attr("transform", "translate(" + width + "," + 0 + ")")
                    .attr('name', 'gridX')
                    .call(d3.axisLeft(y).tickSize(width).tickFormat(""));

                    // ▀█▀ ▀█▀ █▀▀ █▄ ▄█ █▀▀ 
                    // ▄█▄  █  ██▄ █ ▀ █ ▄██ 

                items = scope.svg.selectAll('rect')
                    .data(bins)
                    .join('rect')
                    .attr('x', 1)
                    .attr('transform', function (d) { return 'translate(' + x(d.x0) + ',' + y(d.sum) + ')'; })
                    .attr('width', function (d) { return x(d.x1) - x(d.x0) })
                    .attr('height', function (d) { return height - y(d.sum); })
                    .attr('rx', scope.defaultRadius)
                    .attr('ry', scope.defaultRadius)
                    .attr("data-id", function (d, i) {
                        scope.groups[d.x0] = this;
                        return bins.x0;
                    });
            }
            else {

                // █▀▀ █▀▀ ▄▀▄ █   █▀▀ 
                // ▄██ █▄▄ █▀█ █▄▄ ██▄ 

                let y = d3.scaleLinear()
                    .domain([min, max])
                    .range([height, 0]);

                let histogram = d3.histogram()
                    .value(function (d) { return d.key; })
                    .domain(y.domain())
                    .thresholds(y.ticks(divs));

                let bins = histogram(dataArr);

                bins.forEach(bin => {
                    bin.sum = bin.map(d => d.value).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
                });

                bins.forEach(bin => {
                    let ids = [];
                    bin.forEach(element => {
                        element.ids.forEach(id => {
                            scope.elements[id] = bin.x0;
                            ids.push(id);
                        });
                    });
                    scope.data[bin.x0] = {
                        key: bin.x0,
                        min: bin.x0,
                        max: bin.x1,
                        ids: ids,
                        value: bin.sum,
                    };
                });

                scope.bins = bins

                let x = d3.scaleLinear()
                    .range([0, width]);
                x.domain([0, Math.max.apply(null, bins.map(d => d.sum))]);

                // ▄▀▄ ▀▄▀ ▀█▀ █▀▀ 
                // █▀█ █ █ ▄█▄ ▄██   

                axisY = scope.svg.append('g')
                    .attr('name', 'axisY')
                    .attr('transform', "translate(" + scope.paddingX + "," + height + ")")
                    .call(d3.axisBottom(x));

                axisX = scope.svg.append('g')
                    .attr('name', 'axisX')
                    .attr('transform', "translate(" + scope.paddingX + "," + 0 + ")")
                    .call(d3.axisLeft(y));

                    // █▀▀ █▀█ ▀█▀ █▀▄ 
                    // █▄█ █▀▄ ▄█▄ █▄▀ 

                gridX = scope.svg.append("g")
                    .attr('transform', "translate(" + scope.paddingX + "," + height + ")")
                    .attr('name', 'gridX')
                    .call(d3.axisBottom(x).tickSize(-height).tickFormat(""));

                gridY = scope.svg.append("g")
                    .attr("transform", "translate(" + (width+scope.paddingX) + "," + 0 + ")")
                    .attr('name', 'gridY')
                    .call(d3.axisLeft(y).tickSize(width).tickFormat(""));

                    // ▀█▀ ▀█▀ █▀▀ █▄ ▄█ █▀▀ 
                    // ▄█▄  █  ██▄ █ ▀ █ ▄██ 

                items = scope.svg.selectAll('rect')
                    .data(bins)
                    .join('rect')
                    .attr('y', 1)
                    .attr('transform', "translate(" + scope.paddingX + "," + 0 + ")")
                    .attr('height', function (d) { return (y(d.x0) - y(d.x1)) })
                    .attr('width', function (d) { return x(d.sum); })
                    .attr('rx', scope.defaultRadius)
                    .attr('ry', scope.defaultRadius)
                    .attr("data-id", function (d, i) {
                        scope.groups[d.x0] = this;
                        return bins.x0;
                    });
            }

            // █▀▀ █▀█ █▀█ █▄ ▄█ ▄▀▄ ▀█▀ ▀█▀ ▀█▀ █▄ █ █▀▀ 
            // █▀  █▄█ █▀▄ █ ▀ █ █▀█  █   █  ▄█▄ █ ▀█ █▄█ 
            utils.formatFillItem(items, scope.tooltip, scope.defaultColor);
            utils.formatAxis(axisX, formatting.xAxis, scope.axisColor, 1.0, scope.formatting.axisAngle);
            utils.formatAxis(axisY, formatting.yAxis, scope.axisColor, 1.0, scope.formatting.axisAngle);
            utils.formatGrid(gridX, formatting.xGrid, scope.gridColor, scope.gridOpacity);
            utils.formatGrid(gridY, formatting.yGrid, scope.gridColor, scope.gridOpacity);

            let returnValue = {
                'status': 'success',
                'message': 'Histogram plot added'
            }
            scope.plotAdded = true
            return returnValue;
        }
        catch (err) {
            let returnValue = {
                'status': 'failed',
                'message': 'Failed to add histogram plot.' + err.message
            }
            return returnValue;
        }
    }

    resizeChart(){
        let scope = this;

        // Get new dimensions
        let width = scope.canvas.clientWidth - scope.margin.left - scope.margin.right - scope.paddingX;
        let height = scope.canvas.clientHeight - scope.margin.top - scope.margin.bottom - scope.paddingY -20;

        // Update SVG dimensions
        d3.select(scope.canvas).select("svg")
            .attr("viewBox", `0 0 ${scope.canvas.offsetWidth} ${scope.canvas.offsetHeight}`);

        let x, y;

        if (scope.flipAxis) {
            x = d3.scaleLinear()
                .domain([scope.min, scope.max])
                .range([0, width]);

            y = d3.scaleLinear()
                .range([height, 0])
                .domain([0, Math.max.apply(null, scope.bins.map(d => d.sum))]);

            // Update axes
            scope.svg.selectAll('g[name="axisX"]')
                .attr('transform', 'translate(0,' + height + ')')
                .call(d3.axisBottom(x));

            scope.svg.selectAll('g[name="axisY"]')
                .call(d3.axisLeft(y));

            // Update grids
            scope.svg.selectAll('g[name="gridY"]')
                .attr("transform", "translate(" + 0 + "," + height + ")")
                .call(d3.axisBottom(x).tickSize(-height).tickFormat(""));

            scope.svg.selectAll('g[name="gridX"]')
                .attr("transform", "translate(" + width + "," + 0 + ")")
                .call(d3.axisLeft(y).tickSize(width).tickFormat(""));

            // Update bars
            scope.svg.selectAll('rect')
                .attr('transform', function (d) { return 'translate(' + x(d.x0) + ',' + y(d.sum) + ')'; })
                .attr('width', function (d) { return x(d.x1) - x(d.x0); })
                .attr('height', function (d) { return height - y(d.sum); });

        } else {
            //Recreate Scales
            y = d3.scaleLinear()
                .domain([scope.min, scope.max])
                .range([height, 0]);

            x = d3.scaleLinear()
                .range([0, width])
                .domain([0, Math.max.apply(null, scope.bins.map(d => d.sum))]);

            // Update axes
            scope.svg.selectAll('g[name="axisY"]')
                .attr('transform', "translate(" + scope.paddingX + "," + height + ")")
                .call(d3.axisBottom(x));

            scope.svg.selectAll('g[name="axisX"]')
                .attr('transform', "translate(" + scope.paddingX + "," + 0 + ")")
                .call(d3.axisLeft(y));

            // Update grids
            scope.svg.selectAll('g[name="gridX"]')
                .attr('transform', "translate(" + scope.paddingX + "," + height + ")")
                .call(d3.axisBottom(x).tickSize(-height).tickFormat(""));

            scope.svg.selectAll('g[name="gridY"]')
                .attr("transform", "translate(" + (width+scope.paddingX) + "," + 0 + ")")
                .call(d3.axisLeft(y).tickSize(width).tickFormat(""));

            // Update bars
            scope.svg.selectAll('rect')
                .attr('transform', "translate(" + scope.paddingX + "," + 0 + ")")
                .attr('height', function (d) { return y(d.x0) - y(d.x1); })
                .attr('width', function (d) { return x(d.sum); });
        }
    }

    // █████ █████ █     █████  ████ █████ 
    // █     █     █     █     █       █   
    // █████ ████  █     ████  █       █   
    //     █ █     █     █     █       █   
    // █████ █████ █████ █████  ████   █  
    
    getSelectedElementIds(group){
        let scope = this;
        return scope.data[group.__data__.x0].ids;
    }

    selectElements(elementIDs) {
        let scope = this;


        if (scope.highlightElementFlagCheck) {
            if (scope.svg != undefined) {
                if (elementIDs) {
                    let elems = {};
                    elementIDs.forEach(id => {

                        let key = scope.elements[id];

                        if (!elems[key]) elems[key] = [];
                        elems[key].push(id);

                    });

                    Object.keys(elems).forEach(key => {
                        var element = d3.select(scope.groups[key]);
                        if (scope.data[key]) {
                            if (scope.data[key].ids.length === elems[key].length) {
                                scope.applySelectionColor(element);
                            }
                            else {
                                scope.applyPartialSelectionColor(element);
                            }
                        }
                    });
                }
            }
        }
    }


    // █   █ █████  ████ █   █ █     █████  ████ █   █ █████ 
    // █   █   █   █     █   █ █       █   █     █   █   █   
    // █████   █   █  ██ █████ █       █   █  ██ █████   █   
    // █   █   █   █   █ █   █ █       █   █   █ █   █   █   
    // █   █ █████  ███  █   █ █████ █████  ███  █   █   █   
    
    // Highlight event
    highlightGroup(highlightedElement, event, callBack, group){
        let scope = this;

        if (group.__data__ != undefined) {
        let selData = scope.data[group.__data__.x0];
        scope.applyHighlightColor(highlightedElement);
        scope.applyToolTip(event, group.__data__.x0);
        callBack([...new Set(selData.ids)]);
        }

        else {
            callBack("");
            plotMgrInstance.deHighlightElementsInAllPlots();
          }
      }
    
    //Apply ToolTip
    buildTooltipContent(id) {
        let scope = this;
        let content ="<strong>" + scope.keys.x + "</strong> | " + scope.data[id].ids.length + "<br/>";
        content += "<strong> Subset </strong> | <i>(" + scope.data[id].min + " - " + scope.data[id].max + ")</i> <br/>";
        return content;
      }

}
export { HistogramPlot }
